exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.frhomolo-component .weui-btn:after {\r\n  width: calc(200% - 2px);\n}\r\n", ""]);

// exports
